module.exports = __webpack_public_path__ + "img/devices.225274c8.png";